module.exports = __webpack_public_path__ + "static/media/fair_light_4550.png.947987fe.webp";